import { Typography } from "@mui/material";
import { convertGoogleTimeStampsToDates } from "../helpers/convertGoogleTimeStampsToDates";

function daysBetween(date1, date2) {
  // The number of milliseconds in one day
  const oneDay = 1000 * 60 * 60 * 24;

  // Set times to midnight to ignore the time component and DST issues
  const start = new Date(date1);
  const end = new Date(date2);
  start.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);

  // Calculate the difference in milliseconds
  const differenceMs = Math.abs(end.getTime() - start.getTime());

  // Convert back to days and return
  // Using Math.round helps handle edge cases with DST transitions
  return Math.round(differenceMs / oneDay);
}

export default function ClosingPanel({ closeDate, title }) {
  // console.log(closeDate);
  return (
    <div>
      <Typography
        variant="h4"
        fontWeight={700}
        color="primary"
        // sx={{ color: "#349fda" }}
      >
        {`TIME TO CLOSE:`}
      </Typography>
      <Typography
        variant="h2"
        fontWeight={700}
        color="secondary.light"
        // sx={{ color: "#349fda" }}
      >
        {`${daysBetween(new Date(), convertGoogleTimeStampsToDates(closeDate))} day${daysBetween(new Date(), convertGoogleTimeStampsToDates(closeDate)) === -1 || daysBetween(new Date(), convertGoogleTimeStampsToDates(closeDate)) === 1 ? "" : "s"}`}
      </Typography>
    </div>
  );
}
